export default "__VITE_PUBLIC_ASSET__6e079c5b__"